import { OpenedWhiteboard } from 'features/room/types';
import { ContentLibraryOpenedWhiteboard } from 'features/content-library/types';
import { SignalingWhiteboardPayload } from 'features/layout/features/content/types';

export type WhiteboardData = OpenedWhiteboard | SignalingWhiteboardPayload;

export const formatToWhiteboardFile = (data: WhiteboardData): ContentLibraryOpenedWhiteboard => ({
  url: '',
  shapes: [],
  date: new Date().toISOString(),
  type: 'whiteboard',
  ...data,
});

export const formatWhiteboards = (
  data: Record<string, WhiteboardData>
): Record<string, ContentLibraryOpenedWhiteboard> =>
  Object.keys(data).reduce(
    (result, whiteboardId) => ({
      ...result,
      [whiteboardId]: formatToWhiteboardFile(data[whiteboardId]),
    }),
    {}
  );
